interface IProgressConfig {
  onUploadProgress: (progressEvent: ProgressEvent) => number;
}

export default function progressConfig(onUpdate?: (percent: number) => void): IProgressConfig {
  return {
    onUploadProgress(progressEvent: ProgressEvent) {
      const percentCompleted = Math.round((progressEvent.loaded * 100)
       / progressEvent.total);

      if (onUpdate) {
        onUpdate(percentCompleted);
      }
      return percentCompleted;
    },
  };
}
